<template>
    <v-app-bar app
        v-if="currentRouteName == 'login' || currentRouteName == 'preafiliacion' || currentRouteName == 'recuperarPassword'"
        dark color="primary" :height="(currentRouteName == 'login')
            || (currentRouteName == 'recuperarPassword') || currentRouteName == 'preafiliacion' ? 140 : 60"
        elevation="5">
        <div v-if="currentRouteName == 'login' || currentRouteName == 'preafiliacion' ||
            currentRouteName == 'recuperarPassword'" class="d-flex flex align-center justify-center">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-img v-bind="attrs" v-on="on" @click="irALogin" width="310" max-width="310"
                        src="@/assets/Logo-bt-06.png" />
                </template>
                <span>Home</span>
            </v-tooltip>
        </div>
        <div v-else-if="(currentRouteName == 'recuperarPassword')" color="primary" class="d-flex flex align-center">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon @click="irALogin" @keydown.esc="irALogin">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </template>
                <span>Volver</span>
            </v-tooltip>
            <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        </div>
    </v-app-bar>
</template>

<script>

export default {
    data() {
        return {

        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name
        },

        titulo() {
            if (this.currentRouteName == 'preafiliacion')
                return 'Completá tu afiliacion'
            else
                return 'Reestablecer contraseña'
        }
    }
    ,
    methods: {
        irALogin() {
            this.$router.push('/login').catch(() => { })
        }
    },
}

</script>